
define(function (require) {
    "use strict";

    var template = require("personalization-web-agent-templates/widget-templates/widget-edit/widgetEditLayout.tmpl");

    var WidgetEditLayout = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetEditLayout = Marionette.Layout.extend({
            className: "widget-edit-container",
            template: template,
            ui:{
                widgetEditRegion: ".widget-edit-region",
                widgetEditParamsRegion: ".widget-edit-params-region"
            },
            regions: {
                widgetEditRegion: ".widget-edit-region",
                widgetEditParamsRegion: ".widget-edit-params-region"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function () {
                LEPersonalization.logger.info("Initializing WidgetEditLayout", "WidgetEditLayout:initialize");
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering WidgetEditLayout", "WidgetEditLayout:onRender");
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetEditLayout", "WidgetEditLayout:onClose");
            }
        });

    });
    return WidgetEditLayout;
});